import React, { Component } from 'react'
import { connect } from 'react-redux'
import { login } from './actions'
import { push } from 'react-router-redux'
import { connectForm, Form, Field, Submit } from '~/form'
import { Grid, Segment, Header, Message, Button } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import Promise from 'bluebird'
import Logo from '../common/logo'
import Helmet from 'react-helmet'

class AuthLoginContainer extends Component {
  static formSubmit(dispatch, formId, values, changed) {
    dispatch(login(values.get('email'), values.get('password')))
  }

  static formValidation = {
    email: ['required', 'email'],
    password: ['required'],
  }

  componentDidMount() {
    let { isLoggedIn, redirectToApp } = this.props

    // if (isLoggedIn)
    //   redirectToApp()
  }

  render() {
    let { formUpdate, formSubmit, formState, formLoading, loginError, isLoggedIn } = this.props

    return (
      <div className="auth-login">
        <Helmet>
          <title>Kirjaudu sisään</title>
        </Helmet>
        <Grid verticalAlign="middle" stretched>
          <Grid.Column style={{ maxWidth: '450px', margin: 'auto' }}>
            <Segment style={{ border: 'none', padding: 0 }}>
              <div className="auth-login-logo">
                <h2>Kokemuksia ERP</h2>
              </div>
              <div className="auth-login-form">
                {isLoggedIn ? (
                  <div className="auth-login-form-button">
                    <Button content="Siirry sisään" color="green" as={Link} to="/" />
                  </div>
                ) : (
                  <Form size="large" onSubmit={formSubmit} formState={formState}>
                    {loginError ? <Message content={loginError} color="red" size="tiny" /> : null}
                    <Field
                      type="email"
                      name="email"
                      fluid
                      icon="mail"
                      iconPosition="left"
                      placeholder="Sähköposti"
                      onChange={formUpdate}
                      formState={formState}
                    />
                    <Field
                      type="password"
                      name="password"
                      fluid
                      icon="lock"
                      iconPosition="left"
                      placeholder="Salasana"
                      onChange={formUpdate}
                      formState={formState}
                    />
                    <div className="auth-login-form-button">
                      <Submit content="Kirjaudu sisään" icon="sign in" color="green" />
                    </div>
                  </Form>
                )}
              </div>
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    isLoggedIn: state.isLoggedIn,
    loginError: state.loginError,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    login: (email, password) => dispatch(login(email, password)),
    redirectToApp: () => dispatch(push('/')),
  }
}

export default connectForm('auth-login', AuthLoginContainer, mapStateToProps, mapDispatchToProps)
